import integrationApi from '../api'

const TRELLO_ENDPOINT_PREFIX = 'proxy/github/graphql'

export default function gitHubGraphQl(token, query, variables) {
  return integrationApi.graphql(token, TRELLO_ENDPOINT_PREFIX, query, variables)
}

export const CLIENT_ID = 'groove'
